import React from 'react';

function TasksPanel({ tasks, onCompleteTask, onDeleteTask, onOpenWorkoutTracker }) {
  const activeTasks = tasks.filter(t => !t.completed);

  return (
    <div className="tasks-section">
      <div className="tasks-header">
        <button
          type="button"
          className="tasks-title-btn"
          onClick={onOpenWorkoutTracker}
          title="Track progress"
        >
          <span>Today's Tasks</span>
          <span className="tasks-title-hint">Track progress</span>
        </button>
      </div>
      <div className="tasks-list">
        {activeTasks.map(task => (
          <div key={task.id} className="task-item">
            <div className="task-info">
              <h3>
                {task.title}
                {task.recurring && (
                  <span className="recurring-badge">
                    {task.recurring === 'daily' ? '📅' : '📆'}
                  </span>
                )}
              </h3>
              <p>{task.description}</p>
              <span className="xp-reward">+{task.xpReward} XP</span>
              {task.goalSource === 'google-fit' && (
                <span className="exercise-meta">
                  📊 Google Fit goal: {task.metricType === 'heartRate' ? `${task.targetValue} bpm` : `${task.targetValue} steps`}
                </span>
              )}
              {task.type === 'exercise' && (
                <span className="exercise-meta">
                  {task.sets}x{task.reps} {task.duration > 0 && `• ${task.duration}s`}
                </span>
              )}
            </div>
            <div className="task-actions">
              <button
                className="complete-btn"
                onClick={() => onCompleteTask(task.id)}
                title="Mark complete"
              >
                ✓
              </button>
              <button
                className="delete-btn"
                onClick={() => onDeleteTask(task.id)}
                title="Delete task"
              >
                🗑
              </button>
            </div>
          </div>
        ))}
        {activeTasks.length === 0 && (
          <p className="no-tasks">No tasks yet! Add one below.</p>
        )}
      </div>
    </div>
  );
}

export default TasksPanel;
